import {
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_ERROR,
    FETCH_MESSAGES_LOADING,

    RESET_MESSAGES,
    FETCH_MORE_MESSAGES_SUCCESS,
    FETCH_MORE_MESSAGES_LOADING,
    SET_CHAT_MESSAGE,

    SET_CHAT_PHONE_NO,
    FETCH_CHAT_LOADING,
    FETCH_CHAT_SUCCESS,
    FETCH_CHAT_ERROR,
    SEND_MESSAGE_LOCAL,
    UPDATE_NOTES_MESSAGE,

    FETCH_CHAT_UNREAD_COUNT_SUCCESS,
    FETCH_RESPONSE_COUNT_SUCCESS,
    FETCH_RESPONSIBLE_LIST_SUCCESS,

    FETCH_ALL_MESSAGES_SUCCESS,
    FETCH_ALL_MORE_MESSAGES_SUCCESS,

    FETCH_CONVERSATION_AI_STATUS_SUCCESS,
    UPDATE_CONVERSATION_AI_STATUS_SUCCESS,
} from "./index"

import { apiCall, platform } from "../../functions/utils"

export const fetchMessagesSuccess = (data) => {
    return {
        type: FETCH_MESSAGES_SUCCESS,
        payload: data.data,
        meta: data.meta
    }
}

export const fetchAllMessagesSuccess = (data, store, accountId = false) => {
    let { messages, authUser } = store;
    let all_data = messages.all_data
    let activeAccount = authUser.activeAccount
    if (accountId) {
        activeAccount = accountId
    }
    all_data[activeAccount] = {
        data: data.data,
        meta: data.meta,
    }
    return {
        type: FETCH_ALL_MESSAGES_SUCCESS,
        payload: all_data
    }
}

export const fetchAllMoreMessagesSuccess = (data, store) => {
    let { messages, authUser } = store;
    let all_data = messages.all_data
    let { activeAccount } = authUser
    all_data[activeAccount] = {
        data: all_data[activeAccount].data.concat(data.data),
        meta: data.meta,
    }
    console.log("fetchAllMoreMessagesSuccess", all_data);
    return {
        type: FETCH_ALL_MORE_MESSAGES_SUCCESS,
        payload: all_data
    }
}

export const fetchMoreMessagesSuccess = (data) => {
    return {
        type: FETCH_MORE_MESSAGES_SUCCESS,
        payload: data.data,
        meta: data.meta
    }
}

export const fetchMessagesError = (error) => {
    return {
        type: FETCH_MESSAGES_ERROR,
        error
    }
}



export const fetchMessagesLoading = () => {
    return {
        type: FETCH_MESSAGES_LOADING
    }
}

export const resetMessages = () => {
    return {
        type: RESET_MESSAGES
    }
}

export const fetchMoreMessages = (query = "", meta = false) => {
    return async (dispatch, getState) => {
        let page = 1;
        if (!meta) {
            meta = getState().messages.meta
        }
        if (meta) {
            if (meta.current_page < meta.last_page) {
                page = meta.current_page + 1
                dispatch({
                    type: FETCH_MORE_MESSAGES_LOADING
                })
                try {
                    const res = await apiCall(true, "GET", `/api/messages?query=${query}&page=${page}`)
                    dispatch(fetchMoreMessagesSuccess(res.data))
                    dispatch(fetchAllMoreMessagesSuccess(res.data, getState()))

                } catch (e) {
                    dispatch(fetchMessagesError(e))
                }
            }
        }
    }
}

export const fetchResponseCountData = () => {
    return async (dispatch) => {
        const res = await apiCall(true, "GET", `/api/messages/response-count`)
        dispatch({
            type: FETCH_RESPONSE_COUNT_SUCCESS,
            payload: res.data.data,
        })
    }
}

export const fetchUnReadCountData = () => {
    return async (dispatch) => {
        const res = await apiCall(true, "GET", `/api/messages/unread-count`)
        dispatch({
            type: FETCH_CHAT_UNREAD_COUNT_SUCCESS,
            payload: res?.data?.data,
        })
    }
}

export const fetchResponsibleListData = () => {
    return async (dispatch) => {
        const res = await apiCall(true, "GET", `/api/messages/responsible-list`)
        dispatch({
            type: FETCH_RESPONSIBLE_LIST_SUCCESS,
            payload: res.data.data,
        })
    }
}

//ff_
export const fetchMessages = (query = "", page = 1, tags = false) => {
    let tagId = ""
    if (tags) {
        tagId = tags.id
    }
    return async (dispatch, getState) => {
        dispatch(fetchMessagesLoading())
        try {
            const res = await apiCall(true, "GET", `/api/messages?query=${query}&page=${page}&tag=${tagId}`)
            dispatch(fetchMessagesSuccess(res.data))
            dispatch(fetchAllMessagesSuccess(res.data, getState()))
            dispatch(fetchUnReadCountData())
            dispatch(fetchResponseCountData())
            // dispatch(fetchResponsibleListData())
            if (!getState().messages.chat_phone_no) {
                dispatch(setChatPhone(res.data.data[0].sender_phone))
                dispatch(fetchChat())
            }
        } catch (e) {
            dispatch(fetchMessagesError(e))
        }
    }
}
export const fetchAllMessagesSilently = () => {
    return async (dispatch, getState) => {
        let accounts = getState().authUser.user?.accounts
        if (accounts) {
            accounts.forEach(account => {
                dispatch(fetchSilentMessage("", 1, account.id))
            });
        }
    }
}
//  fetch silent would be without this
export const fetchSilentMessage = (query = "", page = 1, accountId = false) => {
    return async (dispatch, getState) => {
        // dispatch(fetchMessagesLoading())
        try {
            let res;
            if (accountId) {
                res = await apiCall(true, "GET", `/api/messages?query=${query}&page=${page}`, {}, true, true, false, accountId)
            } else {
                res = await apiCall(true, "GET", `/api/messages?query=${query}&page=${page}`)
            }

            if (accountId && getState().authUser.activeAccount != accountId) {
                dispatch(fetchAllMessagesSuccess(res.data, getState(), accountId))
            } else {
                dispatch(fetchMessagesSuccess(res.data))
                dispatch(fetchAllMessagesSuccess(res.data, getState()))
                dispatch(fetchUnReadCountData())
                dispatch(fetchResponseCountData())
                // dispatch(fetchResponsibleListData())
            }
        } catch (e) {
            dispatch(fetchMessagesError(e))
        }
    }
}

export const setChatMessage = (message) => {
    return {
        type: SET_CHAT_MESSAGE,
        payload: message
    }
}

export const setChatPhone = (phone) => {
    return {
        type: SET_CHAT_PHONE_NO,
        payload: phone
    }
}

export const fetchChat = () => {
    return async (dispatch, getState) => {
        console.log("fetchChat", getState());
        dispatch(fetchChatLoading())
        try {
            if (getState().messages.chat_phone_no) {
                const res = await apiCall(true, "POST", `/api/messages/individual-messages`, {
                    contactId_or_number: getState().messages.chat_phone_no,
                    type: 'phone_number'
                })
                if (getState().messages.chat_data.length < 1 || (getState()?.messages?.chat_data && getState()?.messages?.chat_data.length > 0 && getState()?.messages?.chat_phone_no != getState()?.messages?.chat_data[0].phone_no))
                    dispatch(fetchChatSuccess(res.data))
            }
        } catch (e) {
            dispatch(fetchChatError(e))
        }
    }
}

export const fetchSilentChat = () => {
    return async (dispatch, getState) => {
        try {
            if (getState().messages.chat_phone_no) {
                const res = await apiCall(true, "POST", `/api/messages/individual-messages`, {
                    contactId_or_number: getState().messages.chat_phone_no,
                    type: 'phone_number'
                })
                dispatch(fetchChatSuccess(res.data))
            }
        } catch (e) {
            dispatch(fetchChatError(e))
        }
    }
}

export const fetchChatSuccess = (data) => {
    return {
        type: FETCH_CHAT_SUCCESS,
        payload: platform == "mobile" ? data.data : data.data.reverse(),
        meta: data.meta
    }
}

export const fetchChatError = (error) => {
    console.log("fetchChatError", error);
    return {
        type: FETCH_CHAT_ERROR,
        error
    }
}

export const fetchChatLoading = () => {
    return {
        type: FETCH_CHAT_LOADING
    }
}

// export const deleteConversation = () => {
//     return async (dispatch, getState) => {
//         try{

//         }catch(e){
//             console.log("deleteConversation Error", e)
//         } 
//     }
// }

export const sendToNewNumbers = (new_text_message, new_number, type="individual") => {
    return async (dispatch, getState) => {
        try {
            if (new_number && new_text_message) {
                let formData = {};
                formData.new_number = new_number;
                formData.new_text_message = new_text_message;
                formData.type = type;
                const res = await apiCall(true, "POST", `/api/messages/sendToNewNumbers`, formData, false);
            }
        } catch (e) {
            console.log("sendToNewNumbers Error", e)
        }
    }
}

export const sendMessage = (file = null) => {
    return async (dispatch, getState) => {
        try {
            if (getState().messages.chat_message || file) {
                let newMsg = {
                    message: getState().messages.chat_message,
                    message_type: "text",
                    receive_or_sent: "sent",
                    sender_info: {
                        full_name: getState().messages?.chat_data?.[0]?.sender_info?.full_name || "",
                        phone_no: getState().messages.chat_phone_no
                    },
                    file: file ?
                        (platform == "mobile" ? file.uri : URL.createObjectURL(file))
                        : false,
                    sender_phone: getState().messages.chat_phone_no,
                }
                dispatch(sendMessageLocal(newMsg))

                let formData = new FormData();
                formData.append('sent_receive_status', "1")
                formData.append('phone_number', getState().messages.chat_phone_no)
                formData.append('message', getState().messages.chat_message)
                formData.append('contact_or_number_type', 'new_number')
                if(file){  
                  formData.append('photo', file)
                }
                if( getState().authUser.selectedEmployee ) {
                  formData.append('responsible', getState().authUser.selectedEmployee.id) 
                }
                dispatch(setChatMessage(""))
                const res = await apiCall(true, "POST", `/api/messages`, formData, false)
            }
        } catch (e) {
            console.log("sendMessage Error", e)
        }
    }
}

export const sendMessageLocal = (data) => {
    return {
        type: SEND_MESSAGE_LOCAL,
        payload: data
    }
}

export const updateNotesMessage = (input, item) => {
    return {
        type: UPDATE_NOTES_MESSAGE,
        payload: {
            note: input.value,
            id: item.id
        }
    }
}

export const unreadChat = (phone) => {
    return async (dispatch, getState) => {
        let formData = {};
        formData.phone = phone;
        const res = await apiCall(true, "POST", `/api/messages/unread`, formData);
    }
}

export const triggerChatPush = () => {
    return async (dispatch, getState) => {
        const res = await apiCall(true, "GET", `/api/messages/triggerPush`);
    }
}

export const deleteMessageChat = (sender_phone) => {
    return async (dispatch, getState) => {
        let formData = {
            contact_id_or_phone_no: sender_phone,
            type: "phone_no",
        }
        const res = await apiCall(true, "POST", `/api/messages/delete-all`, formData);
    }
}

export const changeMessageReadStatus = (id) => {
    return async (dispatch, getState) => {
        const res = await apiCall(true, "GET", `/api/messages/change-status/${id}`);
    }
}

export const fetchConversationAiStatus = (phoneNo) => {
  return async (dispatch) => {
    dispatch({ type: "FETCH_CONVERSATION_AI_STATUS_LOADING" });

    const res = await apiCall(
      true,
      "GET",
      `/api/conversations/${phoneNo}/ai-status`
    );

    dispatch({
      type: "FETCH_CONVERSATION_AI_STATUS_SUCCESS",
      payload: res.data.ai_enabled,
    });
  };
};

export const updateConversationAiStatus = (phoneNo, enabled) => {
  return async (dispatch) => {
    dispatch({ type: "UPDATE_CONVERSATION_AI_STATUS_LOADING" });

    const res = await apiCall(
      true,
      "POST",
      `/api/conversations/${phoneNo}/ai-status`,
      { ai_enabled: enabled }
    );

    dispatch({
      type: "UPDATE_CONVERSATION_AI_STATUS_SUCCESS",
      payload: res.data.ai_enabled,
    });
  };
};
